
import { Vue, Component } from "vue-property-decorator";
import { ComponentTypeDictionaryService } from "@/app/dynamic-components/forms/form-components/form-component.lookup";
import BaseSectionDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component-section.base";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";

export type FormLinearSectionMetaData = {
  direction: "vertical" | "horizontal";
  evenHorizontalSplit: boolean
  evenHorizontalSplitMinWidth: number
};

@Component({
  components: {DynamicComponentConfigManager},
  computed: {
    ComponentTypeDictionaryService() {
      return ComponentTypeDictionaryService;
    },
  },
})
export default class DumbRenderSection extends BaseSectionDynamicComponent<FormLinearSectionMetaData> {

  screenWidth = window.innerWidth;
  mounted() {
    window.addEventListener("resize", this.updateWidth);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  }

  updateWidth() {
    this.screenWidth = window.innerWidth;
  }

}
